'use client';

import { useEffect, type RefObject } from 'react';

import type { LogoFrame } from './shared-ui-logo-loading.types';

interface Options {
  svgRef: RefObject<SVGSVGElement | null>;
  frame: LogoFrame;
  speed: number;
}

export function useLogoLoadingAnimation({ svgRef, frame, speed }: Options) {
  useEffect(() => {
    const svg = svgRef.current;
    if (!svg) return;

    const paths = svg.querySelectorAll('path');
    let start: number | undefined;
    let raf = 0;

    const tick = (now: number) => {
      start ??= now;
      const elapsed = ((now - start) / 1000) * speed;
      const shapes = frame(Number.isFinite(elapsed) ? elapsed : 0);
      paths.forEach((path, index) => {
        const d = shapes[index];
        if (d) path.setAttribute('d', d);
      });
      raf = requestAnimationFrame(tick);
    };

    raf = requestAnimationFrame(tick);

    return () => cancelAnimationFrame(raf);
  }, [svgRef, frame, speed]);
}
